<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1">
    <defs>
        <linearGradient id="redyel" gradientUnits="objectBoundingBox" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stop-color="#00ff00" />
            <stop offset="100%" stop-color="#ffff00" />
        </linearGradient>
        <linearGradient id="yelgre" gradientUnits="objectBoundingBox" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stop-color="#ffff00" />
            <stop offset="100%" stop-color="#ff0000" />
        </linearGradient>
        <pattern
            id="pattern"
            width="2"
            height="2"
            [attr.stroke]="color"
            stroke-linecap="square"
            stroke-width="2"
            patternTransform="rotate(45) scale(1.2)"
            patternUnits="userSpaceOnUse"
        >
            <line x1="0" y1="0" x2="0" y2="2"></line>
            <line x1="0" y1="0" x2="2" y2="0"></line>
        </pattern>

        <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="1" result="coloredBlur" />
            <feMerge>
                <feMergeNode in="coloredBlur" />
                <feMergeNode in="SourceGraphic" />
            </feMerge>
        </filter>
        <filter id="glowCover" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="1" result="coloredBlur" />
            <feMerge>
                <feMergeNode in="coloredBlur" />
                <feMergeNode in="SourceGraphic" />
            </feMerge>
        </filter>
    </defs>
    <!-- <path
        id="border"
        [attr.d]="rectDimention"
        [attr.stroke]="getUrl('pattern')"
        [style.strokeDasharray]="circumference"
        [style.strokeDashoffset]="dashoffset"
        [attr.stroke-width]="stroke"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="value"
        [attr.filter]="getUrl('glow')"
    /> -->

    <g fill="none" [attr.stroke-width]="stroke" transform="translate(0,0)">
        <path [attr.d]="rectDimentionHalf" [attr.stroke]="getUrl('redyel')" />
        <path class="upDown" [attr.d]="rectDimentionHalf" [attr.stroke]="getUrl('yelgre')" />
    </g>
    <g fill="none" transform="translate(0,0)">
        <path
            id="border"
            [attr.d]="rectDimention"
            [style.strokeDasharray]="circumference"
            [style.strokeDashoffset]="style()"
            [attr.stroke-width]="stroke + 1"
            class="value"
            [attr.stroke]="color"
        />
    </g>
    <!-- <image href="assets/icon/flame.png" height="10" width="12" style="transform: translate(-5px, -5px);">
        <animateMotion
            id="an"
            dur="12s"
            repeatCount="1"
            rotate="auto-reverse"
            begin="0s"
            fill="freeze"
            restart="whenNotActive"
        >
            <mpath xlink:href="#border" />
        </animateMotion>
        <set attributeName="opacity" to="0" begin="an.end" />
    </image> -->
</svg>
